import React from 'react';
import type { IconProps } from '../types';

export const IconColumns: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="2" y="3" width="6" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="12" y="3" width="6" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
  </svg>
);
